import indefinite from 'indefinite';

import { IOTSCommunication } from '@src/types/oneTouchSwitching';

export const commsOptionSplitterHandler = (comms: IOTSCommunication[]) => {
  return comms.map(({ name, value }, i) => (
    <span key={name}>
      {indefinite(name.toLowerCase())}
      {value && (
        <span>
          {' '}
          (<strong>{value}</strong>)
        </span>
      )}
      {i === comms.length - 2 ? ' and ' : ', '}
    </span>
  ));
};
